import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
import { Box } from "./Box";
import { mergeSx } from "../system";
export const menuPopperClasses = {
    root: "MinervaMenuPopper-root",
};
export const MenuPopper = forwardRef(({ className, sx, ...rest }, ref) => {
    return (_jsx(Box, { className: clsx([menuPopperClasses.root, className]), ref: ref, sx: mergeSx({
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            maxHeight: "50dvh",
            boxShadow: (theme) => theme.shadows.md,
            padding: 2,
            borderRadius: (theme) => theme.radius.default,
            overflow: "auto",
            backgroundColor: (theme) => theme.palette.background.main,
            color: (theme) => theme.palette.background.onMain,
            zIndex: (theme) => theme.zIndex.menu,
            outline: "none",
        }, sx), ...rest }));
});
//# sourceMappingURL=MenuPopper.js.map